import { useCallback } from 'react'

import { Checkbox } from 'core-components/library/checkbox'

import styles from '../QBRDocumentsFilterArea.module.scss'

export interface IMyQBRDropdownProps {
  qbrValue: boolean
  onChangeQbrFilter: (value: boolean) => void
}

export const MyQBRDropdown = ({ qbrValue, onChangeQbrFilter }: IMyQBRDropdownProps) => {
  const onQBRChange = useCallback(() => {
    onChangeQbrFilter(!qbrValue)
  }, [qbrValue, onChangeQbrFilter])

  return (
    <div className={styles.filter}>
      <Checkbox
        key={`jbp-qbr-flag-my-qbrs`}
        label="MyQBRs"
        checked={qbrValue}
        onChange={onQBRChange}
      />
    </div>
  )
}
